import { Button } from '@progress/kendo-react-buttons';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { UserApi } from '../../../../../../redux/api/UserApi';

const AddKBButton: React.FC<{ from?: string }> = (props) => {
    const navigate = useNavigate();
    const { data: userProfile } = UserApi.useGetUserProfileQuery();

    //Check if the feature is enabled
    if (!userProfile?.Features.KnowledgeBase || !userProfile?.Features.View_KB) return null;

    return (
        <Button onClick={() => navigate('Kbase/?from=' + props?.from || 'action')} title={'Add links to Knowledge base articles'} imageUrl='./images/Toolbar/kb.png' >
            + KBase
        </Button>
    );
};

export default AddKBButton;